import { MaterialSymbol, SymbolCodepoints } from 'react-material-symbols'

import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import { SelectButton, SelectButtonChangeEvent } from 'primereact/selectbutton'

import i18n from '../../utils/i18n'

export type TypeOptionsFilterTemplate = {
  icon: SymbolCodepoints
  label: string
  value: 'test' | 'web' | 'mail'
}

export const TestAndSourceFilterTemplate = (
  options: ColumnFilterElementTemplateOptions,
) => {
  const filterValue = options.value as TypeOptionsFilterTemplate['value'] | null

  const typeOptions: TypeOptionsFilterTemplate[] = [
    {
      icon: 'science',
      label: i18n.t(
        'eInvoiceOverview.table.columns.testAndSource.options.type.selectButton.test',
      ),
      value: 'test',
    },
    {
      icon: 'language',
      label: i18n.t(
        'eInvoiceOverview.table.columns.testAndSource.options.type.selectButton.web',
      ),
      value: 'web',
    },
    {
      icon: 'mail',
      label: i18n.t(
        'eInvoiceOverview.table.columns.testAndSource.options.type.selectButton.mail',
      ),
      value: 'mail',
    },
  ]

  const selectButtonTemplate = (option: TypeOptionsFilterTemplate) => {
    return (
      <>
        <MaterialSymbol icon={option.icon} size={20} />
        <span
          className="p-button-label p-c white-space-nowrap"
          data-pc-section="label"
        >
          {option.label}
        </span>
      </>
    )
  }

  return (
    <div className="flex flex-column gap-2">
      <label htmlFor="testFilter" className="text-sm font-bold">
        {i18n.t(
          'eInvoiceOverview.table.columns.testAndSource.options.type.label',
        )}
      </label>
      <SelectButton
        id="testFilter"
        value={filterValue}
        onChange={(e: SelectButtonChangeEvent) =>
          options.filterCallback(e.value)
        }
        itemTemplate={selectButtonTemplate}
        optionLabel="label"
        optionValue="value"
        options={typeOptions}
        className="mb-3"
      />
    </div>
  )
}
